export const formDataConverter = (input: any) => {
  const formData = new FormData();
  formData.append('file', input);
  return formData;
};
